import React from "react";
import styles from "../../Product.module.scss";

type Props = {
  productId: string;
};

const TAProductLogo: React.FC<Props> = ({ productId }) => {
  const logoMap: Record<string, string> = {
    "59afbefb-b0d9-4e10-9273-b6c59b81e345":
      "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,h_150,dpr_2/v1758516381/recruit/media%20logos/individualTaLogo/2025_1_c.png",
    "5375d9fa-7def-4938-b006-b97a44a4bd2e":
      "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,h_150,dpr_2/v1758516381/recruit/media%20logos/individualTaLogo/2025_2_c.png",
    "ff345d77-8741-4669-aef1-e0d979c2361f":
      "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,h_150,dpr_2/v1720060337/recruit/media%20logos/individualTaLogo/kyotota.png",
    "e97da2a4-a99c-4ec8-b2c2-e5e9ae25a8f6":
      "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,h_200,dpr_2/v1720060337/recruit/media%20logos/individualTaLogo/2025_3_1_c.png",
    "61494b98-5cf7-4023-8db5-cf8ad92da41e":
      "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,h_200,dpr_2/v1720060337/recruit/media%20logos/individualTaLogo/2025_3_1_c.png",
    "b0423202-29dd-4399-b047-9c6a0ee31ea5":
      "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,h_200,dpr_2/v1720060337/recruit/media%20logos/individualTaLogo/2025_3_1_c.png",
    "4b8953b7-b5d8-46b9-b6b0-3b0f10942a68":
      "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,h_200,dpr_2/v1720060337/recruit/media%20logos/individualTaLogo/2025_3_1_c.png",
  };

  const src = logoMap[productId];

  if (!src) return null;

  return <img className={styles.TAProductLogo} src={src} alt="Ta logo" />;
};

export default TAProductLogo;
